import { render, staticRenderFns } from "./Synastry.vue?vue&type=template&id=321100a9&scoped=true&"
import script from "./Synastry.vue?vue&type=script&lang=js&"
export * from "./Synastry.vue?vue&type=script&lang=js&"
import style0 from "./Synastry.vue?vue&type=style&index=0&id=321100a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321100a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321100a9')) {
      api.createRecord('321100a9', component.options)
    } else {
      api.reload('321100a9', component.options)
    }
    module.hot.accept("./Synastry.vue?vue&type=template&id=321100a9&scoped=true&", function () {
      api.rerender('321100a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/雙人合盤/Synastry.vue"
export default component.exports